import { getByPath } from "../../../../dot-notation/index.js";
function createMutationApi(store) {
  const formMutations = /* @__PURE__ */ new Map();
  const fieldMutations = /* @__PURE__ */ new Map();
  function applyMutations(formApi, initialChangedValues, fieldToSkip) {
    const changedValues = { ...initialChangedValues };
    for (const [targetFieldName, fieldMutation] of fieldMutations) {
      if (fieldToSkip && targetFieldName === fieldToSkip) continue;
      if (fieldMutation) {
        const mutatedValue = fieldMutation(formApi, changedValues, initialChangedValues, targetFieldName);
        const prevValue = getByPath(store.values, targetFieldName);
        if (prevValue !== mutatedValue) {
          changedValues[targetFieldName] = mutatedValue;
        } else {
          delete changedValues[targetFieldName];
        }
      }
    }
    for (const [, formMutation] of formMutations) {
      const mutatedValues = formMutation(formApi, changedValues, initialChangedValues);
      if (mutatedValues) {
        for (const [targetFieldName, mutatedValue] of Object.entries(mutatedValues)) {
          const fieldName = targetFieldName;
          const prevValue = getByPath(store.values, fieldName);
          if (prevValue !== mutatedValue) {
            changedValues[fieldName] = mutatedValue;
          } else {
            delete changedValues[fieldName];
          }
        }
      }
    }
    return changedValues;
  }
  const mutationApi = {
    // -----------------------------------------
    // MUTATIONS
    // ------------------------------------------
    addFormMutation: (id, mutation) => {
      if (formMutations.has(id)) {
        throw new Error(`Trying to register a Form Mutation with ID: ${id} but it's already registered.`);
      }
      formMutations.set(id, mutation);
    },
    removeFormMutation: (id) => {
      return formMutations.delete(id);
    },
    removeAllFormMutations: () => {
      const mutationIds = formMutations.keys();
      for (const mutationId of mutationIds) {
        mutationApi.removeFormMutation(mutationId);
      }
    },
    addFieldMutation: (fieldName, mutation) => {
      if (fieldMutations.has(fieldName)) {
        console.warn(`Overwriting the Form Mutation registered for the field: ${String(fieldName)}.`);
      }
      fieldMutations.set(fieldName, mutation);
    },
    removeFieldMutation: (fieldName) => {
      return fieldMutations.delete(fieldName);
    },
    removeAllFieldMutations: () => {
      const mutationIds = fieldMutations.keys();
      for (const mutationId of mutationIds) {
        mutationApi.removeFieldMutation(mutationId);
      }
    }
  };
  return {
    formMutations,
    fieldMutations,
    applyMutations,
    mutationApi
  };
}
export {
  createMutationApi
};
//# sourceMappingURL=createMutationApi.js.map
